import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "static/images/close.svg";
import { noop } from "lib/utils";
import Button from "components/ui/Button";
import PassengersForm from "components/PassengersForm";
import "styles/components/modal-passengers-form.scss";

const ModalPassengersForm = ({
  className,
  onClose = noop,
  onSave = noop,
  slideUp = true,
  disableRailcards = false,
  ...props
}) => {
  const [adults, setAdults] = useState(props.adults);
  const [children, setChildren] = useState(props.children);
  const [railcards, setRailcards] = useState(props.railcards);

  const handleSave = () => {
    onSave({ adults, children, railcards });
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  const passengers = adults + children;

  return (
    <div className="otrl-jp__modal-passengers-form">
      <div className="otrl-jp__modal-passengers-form__header">
        <div className="otrl-jp__modal-passengers-form__header__bar" onClick={handleClose}>
          <div className="otrl-jp__modal-passengers-form__header__title-wrapper">
            <h1 className="otrl-jp__modal-passengers-form__header__title">Who's travelling?</h1>
          </div>
          <button
            className="otrl-jp__modal-passengers-form__close otrl-jp__button-unstyled"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className="otrl-jp__modal-passengers-form__wrapper">
        <PassengersForm
          adults={adults}
          children={children}
          onAdultsChange={setAdults}
          onChildrenChange={setChildren}
          onRailcardsChange={setRailcards}
          passengers={passengers}
          railcards={railcards}
          disableRailcards={disableRailcards}
        />
      </div>
      <Button
        className="otrl-jp__button--full-width"
        disabled={passengers === 0}
        text="Done"
        onClick={handleSave}
      />
    </div>
  );
};

export default ModalPassengersForm;
